module.exports = __webpack_public_path__ + "static/pinkmummyme6-72d34acb0938f7f2d9eb1b2c630dec7b.png";